var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomOut24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.415 20.6l-4.2-4.196a10.496 10.496 0 00-1.993-13.99 10.522 10.522 0 00-14.13.65A10.5 10.5 0 009 20.9a10.523 10.523 0 007.393-1.684l4.21 4.205a1.996 1.996 0 003.246-.647 1.993 1.993 0 00-.433-2.173zM10.536 2.074a8.486 8.486 0 017.834 5.23 8.463 8.463 0 01-1.838 9.231 8.481 8.481 0 01-9.241 1.836 8.478 8.478 0 01-5.235-7.826 8.476 8.476 0 012.487-5.987 8.493 8.493 0 015.993-2.484z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12h7a1 1 0 000-2H7a1 1 0 000 2z"
  })));
}
export default SvgZoomOut24;